import React from 'react';
import PropTypes from 'prop-types';

import { renderToString } from 'react-dom/server';

import AddFavorite from 'components/AddFavorite';
import Image from 'components/Image';
import LinkHandler from 'components/LinkHandler';
import SharingPopup from 'components/SharingPopup';
import WebsiteSplitter from 'components/WebsiteSplitter';

import { appContentUrl } from 'settings';

const parseURL = (url, type, appId) => {
  switch (type) {
    case 'pdf':
      return `${appContentUrl}${appId}/${typeof url === 'object' ? url[0] : url}`;
    case 'image':
      return `${appContentUrl}${appId}/${typeof url === 'object' ? url[0] : url}`;
    default:
      return url;
  }
};

const Slideshow = (props) => {
  const { appId, fancybox, options, urls } = props;

  const images = [];
  for (let i = 1; i < urls.length; i += 1) {
    const key = i;
    images.push(
      <div
        key={`ss_${key}`}
        href={urls[i].includes('http') ? urls[i] : parseURL(urls[i], 'image', appId)}
        data-options={options}
        data-fancybox={fancybox}
        data-trigger={fancybox}
        data-type={urls[i].includes('http') && 'iframe'}
        style={{ display: 'none' }}
      >
        <Image src={parseURL(urls[i], 'image', appId)} overrideZeroSize={100} alt="hidden" />
      </div>,
    );
  }
  return images;
};

const FavoriteLink = (props) => {
  const { info } = props;
  const { image, pageID, sub_type: subType, subtitle, title, type: originType } = info;

  const { favorites } = props;

  const { contentInfo } = props;
  const { unid, type, app_id: appId } = contentInfo;

  let { url } = info;
  if (url) {
    if (url.includes(',')) {
      url = url.split(',');
    }
  }

  let shareUrl = url;
  if (Array.isArray(shareUrl)) {
    shareUrl = window.location.href;
  } else {
    shareUrl = `${appContentUrl}${appId}/${shareUrl}`;
  }

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'x',
    },
    baseClass: 'customBox',
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={shareUrl} />),
    },
  };

  const favSubtype = info.subType;
  return (
    <div className="favorite__card" key={pageID}>
      <AddFavorite appId={appId} favorites={favorites} viewType={type} upID={unid} color />
      <LinkHandler
        info={info}
        appId={appId}
        url={url}
        type={type}
        subType={favSubtype}
        title={title}
        UniqueID={pageID}
        dataOptions={JSON.stringify(fancyOptions)}
        dataFancybox={pageID}
        dataTrigger={pageID}
        className="favorite__button"
        page="f"
      >
        {/* Dummy image to fool fancybox thumbnails process */}
        {typeof url === 'object' && (
          <Image src={`${appContentUrl}${appId}/${url[0]}`} alt="placeholder thumbnail" className="hidden" />
        )}
        <div className="favorite__image--container">
          <Image src={image} alt={unid} />
        </div>
        <h4>{title}</h4>
        <p>{subtitle}</p>
      </LinkHandler>
      {typeof url === 'object' && (
        <Slideshow appId={appId} fancybox={pageID} options={JSON.stringify(fancyOptions)} urls={url} />
      )}
      {subType === 'multi' && (
        <WebsiteSplitter itemID={pageID} appID={appId} type={originType !== 'toolbox' ? 'FastFacts' : originType} />
      )}
    </div>
  );
};

export default FavoriteLink;

FavoriteLink.propTypes = {
  info: PropTypes.shape(PropTypes.string.isRequired),
  favorites: PropTypes.shape(),
  contentInfo: PropTypes.shape(PropTypes.string.isRequired),
};

FavoriteLink.defaultProps = {
  contentInfo: {},
  favorites: {},
  info: {},
};
